import React, { useContext } from 'react';
import Header from './header';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';

const { isSearchResultsPage, listerData } = window.globalLister;

function HeaderContainer(): React.ReactElement | null {
  const [formattedMessage] = useContext(MessagePropertiesContext);

  const messages = {
    spellingSuggestionHeadingText: formattedMessage({
      id: 'search.meta.spelling.suggestion.heading',
      values: { 0: listerData.currentQuery.freeTextSearch },
      fallback: `You searched for <em>${listerData.currentQuery.freeTextSearch}</em>`
    }),
    spellingSuggestionResultText: formattedMessage({
      id: 'search.meta.spelling.suggestion.result',
      fallback: "We're showing results for"
    }),
    searchResultText: formattedMessage({
      id: 'search.meta.search.result',
      fallback: 'You searched for'
    }),
    suggestion: listerData.spellingSuggestion?.suggestion || '',
    resultsLength: `${listerData.pagination.totalNumberOfResults}`,
    query: listerData.currentQuery.freeTextSearch
  };

  return isSearchResultsPage ? <Header messages={messages} /> : null;
}

export default HeaderContainer;
